import {ActionTree} from 'vuex'
import {AxiosError, AxiosResponse} from "axios";
// @ts-ignore
import Api from "@/api.js";

export const actions: ActionTree<any, any> = {

    saveFingerprint: ({state, getters, commit, dispatch}, data) => {

        commit('setLoading', true);

        return new Promise((resolve, reject) => {

            Api.put('/landing-entry/fingerprint', data)

                .then((response: AxiosResponse) => {

                    if (response.status === 200) {
                        commit('setLoading', false);
                    }
                    resolve(response.data);

                })
                .catch((error: AxiosError) => {
                    commit('setLoading',false);
                    reject(error);
                });
        });
    },
};
